import React from 'react'

import ContactUs from "./ContactUs.js";

import "./Licenses.scss"

const LicensesData = [{
  "title": "Blacklists",
  "features": [{
    "i": "fa-solid fa-list", "text": "Blacklists",
  }, {
    "i": "fa-solid fa-envelope", "text": "E-Mail Support",
  }, {
    "i": "fa-solid fa-check", "text": "10K Req/Month",
  }],
}, {
  "title": "Research",
  "features": [{
    "i": "fa-solid fa-list", "text": "Blacklists",
  }, {
    "i": "fa-solid fa-envelope", "text": "E-Mail Support",
  }, {
    "i": "fa-solid fa-check", "text": "10K Req/Month",
  }, {
    "i": "fa-solid fa-magnifying-glass", "text": "Full Research API",
  }],
}, {
  "title": "Enterprise",
  "features": [{
    "i": "fa-solid fa-list", "text": "Blacklists",
  }, {
    "i": "fa-solid fa-headset", "text": "Full Support",
  }, {
    "i": "fa-solid fa-check", "text": "50K Req/Month",
  }, {
    "i": "fa-solid fa-magnifying-glass", "text": "Full Research API",
  }, {
    "i": "fa-solid fa-check", "text": "Commercial",
  }],
}];

function Licenses() {
  function makeCard(license) {
    return (
      <div className="column">
        <div className="card">
          <header className="card-header">
            <p className="card-header-title">{license["title"]}</p>
          </header>
          <div className="card-content honey-licenses-card-content">
            <div className="content">
              <ul className="honey-licenses-ul">
                {license["features"].map((feature) => (
                  <li className="honey-licenses-li">
                    <span className="icon honey-licenses-icon">
                      <i className={feature["i"]}></i>
                    </span>
                    {feature["text"]}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <footer className="card-footer">
            <div className="card-footer-item">Purchase</div>
          </footer>
        </div>
      </div>
    )
  }

  return (
    <div className="container block is-max-desktop">
      <div className="container block">
        <h3 className="has-text-weight-bold is-size-3 honey-text-font-family-common honey-text-common">
          Licenses
        </h3>
      </div>
      <h5 className="has-text-weight-bold is-size-5 honey-text-font-family-common honey-text-common">
        Available Soon.
      </h5>
      <h5 className="has-text-weight-bold is-size-5 honey-text-font-family-common honey-text-common">
        Can't wait?
      </h5>
      <ContactUs />
    </div>
  );
}

export default Licenses;

        // <div className="columns">
        //   {LicensesData.map((license) => (
        //     makeCard(license)
        //   ))}
        // </div>
